import React from 'react';

const ResetPassword = () => {
	return (
		<div style={{ textAlign: 'center', marginTop: '20%' }}>
			<h1>Page Under Construction</h1>
			<p>We are working hard to bring this page to you soon. Stay tuned!</p>
		</div>
	);
};

export default ResetPassword;